import React, { useState } from 'react';
import { DicesIcon, MapPinIcon, UsersIcon, CalendarIcon, ClockIcon, UserIcon, Gamepad2Icon, ChevronRightIcon, MailIcon, LockIcon, ArrowLeftIcon } from 'lucide-react';
function AuthPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle auth logic here
    console.log(isLogin ? 'Logging in...' : 'Signing up...', {
      email,
      password,
      name
    });
  };
  return <main className="min-h-screen w-full bg-slate-50 relative overflow-hidden" data-id="element-0">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `
            linear-gradient(to right, #4f46e5 1px, transparent 1px),
            linear-gradient(to bottom, #4f46e5 1px, transparent 1px)
          `,
      backgroundSize: '48px 48px'
    }} data-id="element-1" />

      <div className="relative z-10 min-h-screen flex flex-col" data-id="element-2">
        {/* Header */}
        <nav className="relative flex items-center justify-center px-6 py-6 max-w-7xl mx-auto w-full" data-id="element-3">
          <button onClick={onBack} className="absolute left-6 flex items-center gap-2 text-indigo-600 hover:text-indigo-700 transition-colors" data-id="element-4">
            <ArrowLeftIcon className="w-6 h-6" data-id="element-5" />
          </button>
          <div className="flex items-center gap-2" data-id="element-6">
            <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center shadow-md" data-id="element-7">
              <DicesIcon className="text-white" size={24} data-id="element-8" />
            </div>
            <span className="text-2xl font-semibold text-slate-800 tracking-tight" data-id="element-9">
              Tabletop
            </span>
          </div>
        </nav>

        {/* Auth Form */}
        <div className="flex-1 flex items-center justify-center px-6 py-12" data-id="element-10">
          <div className="w-full max-w-md" data-id="element-11">
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-8" data-id="element-12">
              {/* Toggle */}
              <div className="flex bg-slate-100 rounded-xl p-1 mb-8" data-id="element-13">
                <button onClick={() => setIsLogin(true)} className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all ${isLogin ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-14">
                  Log In
                </button>
                <button onClick={() => setIsLogin(false)} className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all ${!isLogin ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-15">
                  Sign Up
                </button>
              </div>

              <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-16">
                {isLogin ? 'Welcome back!' : 'Create your account'}
              </h1>
              <p className="text-slate-600 mb-6" data-id="element-17">
                {isLogin ? 'Log in to find your next game night.' : 'Join the community and start playing.'}
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-18">
                {!isLogin && <div data-id="element-19">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-20">
                      Full Name
                    </label>
                    <div className="relative" data-id="element-21">
                      <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-22" />
                      <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} placeholder="John Doe" required={!isLogin} className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-shadow" data-id="element-23" />
                    </div>
                  </div>}

                <div data-id="element-24">
                  <label htmlFor="auth-email" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-25">
                    Email Address
                  </label>
                  <div className="relative" data-id="element-26">
                    <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-27" />
                    <input type="email" id="auth-email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-shadow" data-id="element-28" />
                  </div>
                </div>

                <div data-id="element-29">
                  <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-30">
                    Password
                  </label>
                  <div className="relative" data-id="element-31">
                    <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-32" />
                    <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-shadow" data-id="element-33" />
                  </div>
                </div>

                {isLogin && <div className="flex justify-end" data-id="element-34">
                    <button type="button" className="text-sm text-indigo-600 hover:text-indigo-700 font-medium" data-id="element-35">
                      Forgot password?
                    </button>
                  </div>}

                <button type="submit" className="w-full px-6 py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors shadow-lg shadow-indigo-600/20" data-id="element-36">
                  {isLogin ? 'Log In' : 'Create Account'}
                </button>
              </form>

              <div className="mt-6 text-center text-sm text-slate-500" data-id="element-37">
                {isLogin ? <>
                    Don't have an account?{' '}
                    <button onClick={() => setIsLogin(false)} className="text-indigo-600 hover:text-indigo-700 font-medium" data-id="element-38">
                      Sign up
                    </button>
                  </> : <>
                    Already have an account?{' '}
                    <button onClick={() => setIsLogin(true)} className="text-indigo-600 hover:text-indigo-700 font-medium" data-id="element-39">
                      Log in
                    </button>
                  </>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'auth'>('home');
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
    }
  };
  if (currentPage === 'auth') {
    return <AuthPage onBack={() => setCurrentPage('home')} data-id="element-40" />;
  }
  const features = [{
    icon: <MapPinIcon className="w-6 h-6 text-indigo-600" data-id="element-41" />,
    title: 'Find Local Games',
    description: 'Discover board game nights happening in your neighborhood at cafes, game stores, and community centers.'
  }, {
    icon: <UsersIcon className="w-6 h-6 text-indigo-600" data-id="element-42" />,
    title: 'Match by Interest',
    description: 'Connect with players who love the same games you do, from heavy euros to quick party games.'
  }, {
    icon: <CalendarIcon className="w-6 h-6 text-indigo-600" data-id="element-43" />,
    title: 'Easy Scheduling',
    description: 'Coordinate times that work for everyone with our built-in scheduling tools and reminders.'
  }];
  const games = [{
    title: 'Ticket to Ride',
    host: 'Alex M.',
    time: 'Thu, 7:00 PM',
    location: 'The Dice & Latte',
    players: '3/4',
    type: 'Family',
    image: 'https://cf.geekdo-images.com/_Z0_NfPnT6dy1K-E_8WrkA__imagepage/img/EorFAFw9oFkll_b0DW0PA1YsnTg=/fit-in/900x600/filters:no_upscale():strip_icc()/pic8937641.jpg'
  }, {
    title: 'D&D One-Shot',
    host: 'Sarah K.',
    time: 'Sat, 6:00 PM',
    location: 'Community Center',
    players: '4/6',
    type: 'RPG',
    image: 'https://static0.cbrimages.com/wordpress/wp-content/uploads/2025/03/2014-and-the-2024-5e-player-s-handbooks-for-dungeons-dragons-1.jpg?w=1200&h=675&fit=crop'
  }, {
    title: 'Speakeasy',
    host: 'James R.',
    time: 'Sun, 2:00 PM',
    location: 'Downtown Library',
    players: '2/5',
    type: 'Strategy',
    image: 'https://cf.geekdo-images.com/xmC4mlBnwN0lhjRmMZZydw__imagepage/img/_Yw2KHErLDrnWRc2pLvpmC0lJHw=/fit-in/900x600/filters:no_upscale():strip_icc()/pic8433614.jpg'
  }];
  return <main className="min-h-screen w-full bg-slate-50 relative overflow-hidden" data-id="element-44">
      {/* Subtle background pattern - like a game board grid */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `
            linear-gradient(to right, #4f46e5 1px, transparent 1px),
            linear-gradient(to bottom, #4f46e5 1px, transparent 1px)
          `,
      backgroundSize: '48px 48px'
    }} data-id="element-45" />

      {/* Decorative dice scattered around */}
      <div className="absolute top-20 left-[10%] text-indigo-200 rotate-12 opacity-60 pointer-events-none" data-id="element-46">
        <DicesIcon size={48} strokeWidth={1.5} data-id="element-47" />
      </div>
      <div className="absolute top-32 right-[15%] text-indigo-300 -rotate-12 opacity-50 pointer-events-none" data-id="element-48">
        <DicesIcon size={32} strokeWidth={1.5} data-id="element-49" />
      </div>
      <div className="absolute bottom-32 left-[20%] text-indigo-200 rotate-45 opacity-40 pointer-events-none" data-id="element-50">
        <DicesIcon size={40} strokeWidth={1.5} data-id="element-51" />
      </div>
      <div className="absolute bottom-24 right-[12%] text-indigo-300 -rotate-6 opacity-50 pointer-events-none" data-id="element-52">
        <DicesIcon size={36} strokeWidth={1.5} data-id="element-53" />
      </div>

      <div className="relative z-10" data-id="element-54">
        {/* Navigation / Header */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-50/80 backdrop-blur-md border-b border-slate-200/50" data-id="element-55">
          <div className="flex items-center justify-between px-6 py-4 max-w-7xl mx-auto w-full" data-id="element-56">
            <div className="flex items-center gap-2" data-id="element-57">
              <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center shadow-md" data-id="element-58">
                <DicesIcon className="text-white" size={24} data-id="element-59" />
              </div>
              <span className="text-2xl font-semibold text-slate-800 tracking-tight" data-id="element-60">
                Tabletop
              </span>
            </div>
            <button onClick={() => setCurrentPage('auth')} className="text-sm font-medium text-slate-600 hover:text-indigo-600 transition-colors" data-id="element-61">
              Sign up / Log in
            </button>
          </div>
        </nav>

        {/* Spacer for fixed navbar */}
        <div className="h-[72px]" data-id="element-62" />

        {/* Hero Section */}
        <section className="flex flex-col items-center justify-center px-6 py-16 md:py-24 max-w-7xl mx-auto w-full" data-id="element-63">
          <div className="text-center max-w-3xl" data-id="element-64">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-65">
              Find Your Weekly
              <span className="block text-indigo-600" data-id="element-66">Game Night</span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-67">
              Connect with local board gamers that love the same games you do.
              Join a community of players in your area.
            </p>
          </div>
        </section>

        {/* Hosted Games Section */}
        <section className="px-6 py-20" style={{
        backgroundColor: '#f1f5f9'
      }} data-id="element-68">
          <div className="max-w-7xl mx-auto" data-id="element-69">
            <div className="flex flex-col items-center text-center mb-12 gap-4" data-id="element-70">
              <div data-id="element-71">
                <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-72">
                  Upcoming Game Nights
                </h2>
                <p className="text-slate-600" data-id="element-73">
                  Join a game near you. No experience required for most events.
                </p>
              </div>
              <button className="text-indigo-600 font-semibold flex items-center hover:text-indigo-700 transition-colors" data-id="element-74">
                View all games <ChevronRightIcon className="w-4 h-4 ml-1" data-id="element-75" />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-76">
              {games.map((game, index) => <div key={index} className="bg-white rounded-2xl shadow-lg shadow-slate-600/20 border border-white/20 overflow-hidden hover:-translate-y-1 transition-transform duration-300 group" data-id="element-77">
                  <img src={game.image} alt={game.title} className="w-full h-40 object-cover" data-id="element-78" />
                  <div className="p-6" data-id="element-79">
                    <div className="flex justify-between items-start mb-3" data-id="element-80">
                      <h3 className="text-xl font-bold text-slate-900 group-hover:text-indigo-600 transition-colors" data-id="element-81">
                        {game.title}
                      </h3>
                      <span className="px-3 py-1 bg-slate-100 text-slate-600 text-xs font-semibold rounded-full uppercase tracking-wide" data-id="element-82">
                        {game.type}
                      </span>
                    </div>

                    <div className="space-y-3 mb-6" data-id="element-83">
                      <div className="flex items-center text-slate-600 text-sm" data-id="element-84">
                        <UserIcon className="w-4 h-4 mr-2 text-slate-400" data-id="element-85" />
                        Hosted by{' '}
                        <span className="font-medium text-slate-900 ml-1" data-id="element-86">
                          {game.host}
                        </span>
                      </div>
                      <div className="flex items-center text-slate-600 text-sm" data-id="element-87">
                        <ClockIcon className="w-4 h-4 mr-2 text-slate-400" data-id="element-88" />
                        {game.time}
                      </div>
                      <div className="flex items-center text-slate-600 text-sm" data-id="element-89">
                        <MapPinIcon className="w-4 h-4 mr-2 text-slate-400" data-id="element-90" />
                        {game.location}
                      </div>
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-91">
                      <div className="flex items-center text-sm font-medium text-slate-600" data-id="element-92">
                        <UsersIcon className="w-4 h-4 mr-2 text-indigo-500" data-id="element-93" />
                        {game.players} players
                      </div>
                      <button className="text-sm font-semibold text-indigo-600 hover:text-indigo-700 transition-colors" data-id="element-94">
                        Join Game
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="px-6 py-20 bg-gradient-to-b from-slate-50 to-indigo-50/50" data-id="element-95">
          <div className="max-w-7xl mx-auto" data-id="element-96">
            <div className="flex flex-col items-center" data-id="element-97">
              <div className="text-center mb-8" data-id="element-98">
                <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-99">
                  Ready to Find Your Game Night?
                </h2>
                <p className="text-slate-600 max-w-xl mx-auto" data-id="element-100">
                  Join our early sign up list to get notified when we launch!
                </p>
              </div>

              <div className="w-full max-w-md" data-id="element-101">
                <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-8" data-id="element-102">
                  {!isSubmitted ? <form onSubmit={handleSubmit} className="space-y-4" data-id="element-103">
                      <div data-id="element-104">
                        <label htmlFor="email" className="sr-only" data-id="element-105">
                          Email address
                        </label>
                        <input type="email" id="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-shadow" data-id="element-106" />
                      </div>
                      <button type="submit" className="w-full px-6 py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors shadow-lg shadow-indigo-600/20" data-id="element-107">
                        Notify me
                      </button>
                    </form> : <div className="text-center py-4" data-id="element-108">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-109">
                        <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-110">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-111" />
                        </svg>
                      </div>
                      <p className="text-slate-800 font-medium" data-id="element-112">
                        You're on the list!
                      </p>
                      <p className="text-slate-500 text-sm mt-1" data-id="element-113">
                        We'll let you know when we launch.
                      </p>
                    </div>}
                </div>
                <p className="text-center text-slate-400 text-sm mt-4" data-id="element-114">
                  No spam, ever. Unsubscribe anytime.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section - Moved to bottom */}
        <section className="px-6 py-16 bg-white/50 backdrop-blur-sm border-y border-slate-200/50" data-id="element-115">
          <div className="max-w-7xl mx-auto" data-id="element-116">
            <div className="text-center mb-16" data-id="element-117">
              <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-118">
                How Tabletop Works
              </h2>
              <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-119">
                We make it easy to find your people and play more games.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-120">
              {features.map((feature, index) => <div key={index} className="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-121">
                  <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center mb-6" data-id="element-122">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-123">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-124">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-white border-t border-slate-200 py-12 px-6" data-id="element-125">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-126">
            <div className="flex items-center gap-2" data-id="element-127">
              <div className="w-8 h-8 bg-slate-800 rounded-lg flex items-center justify-center" data-id="element-128">
                <DicesIcon className="text-white" size={18} data-id="element-129" />
              </div>
              <span className="text-lg font-semibold text-slate-800" data-id="element-130">
                Tabletop
              </span>
            </div>
            <p className="text-slate-500 text-sm" data-id="element-131">
              © {new Date().getFullYear()} Tabletop. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </main>;
}